import { RestStore } from 'duo-kit'

export const resources = RestStore("/duocms/api/resourcecenter/resources/")